// @ts-nocheck

/**
 * Kenya Population Centers Seed Data
 * 
 * Initial data for Kenya cities with populations >100k.
 * This data should be imported into Firestore msi3PopulationCenters collection.
 * 
 * Each city has a sequenceNumber (1-15) for ordering and display.
 * CityManager roles follow the pattern: Role_CityManager_{CityName}
 */

export const KENYA_CITIES = [
  {
    sequenceNumber: 1,
    cityName: 'Nairobi',
    displayName: 'Nairobi',
    adminDivision1: 'Nairobi County',
    countryCode: 'KE',
    countryName: 'Kenya',
    population: 4400000,
    estimatedChronicDiseasePatients: 440000, // ~10% of population
    latitude: -1.2921,
    longitude: 36.8219,
    currency: 'KES',
    languagePrimary: 'English',
    languageSecondary: 'Swahili',
    region: 'Central',
    status: 'active',
    cityManagerRole: 'Role_CityManager_Nairobi',
  },
  {
    sequenceNumber: 2,
    cityName: 'Mombasa',
    displayName: 'Mombasa',
    adminDivision1: 'Mombasa County',
    countryCode: 'KE',
    countryName: 'Kenya',
    population: 1200000,
    estimatedChronicDiseasePatients: 120000,
    latitude: -4.0435,
    longitude: 39.6682,
    currency: 'KES',
    languagePrimary: 'English',
    languageSecondary: 'Swahili',
    region: 'Coastal',
    status: 'planned',
    cityManagerRole: 'Role_CityManager_Mombasa',
  },
  {
    sequenceNumber: 3,
    cityName: 'Kisumu',
    displayName: 'Kisumu',
    adminDivision1: 'Kisumu County',
    countryCode: 'KE',
    countryName: 'Kenya',
    population: 610000,
    estimatedChronicDiseasePatients: 61000,
    latitude: -0.1022,
    longitude: 34.7617,
    currency: 'KES',
    languagePrimary: 'English',
    languageSecondary: 'Swahili',
    region: 'Lake Victoria',
    status: 'planned',
    cityManagerRole: 'Role_CityManager_Kisumu',
  },
  {
    sequenceNumber: 4,
    cityName: 'Nakuru',
    displayName: 'Nakuru',
    adminDivision1: 'Nakuru County',
    countryCode: 'KE',
    countryName: 'Kenya',
    population: 570000,
    estimatedChronicDiseasePatients: 57000,
    latitude: -0.3031,
    longitude: 36.0800,
    currency: 'KES',
    languagePrimary: 'English',
    languageSecondary: 'Swahili',
    region: 'Rift Valley',
    status: 'planned',
    cityManagerRole: 'Role_CityManager_Nakuru',
  },
  {
    sequenceNumber: 5,
    cityName: 'Eldoret',
    displayName: 'Eldoret',
    adminDivision1: 'Uasin Gishu County',
    countryCode: 'KE',
    countryName: 'Kenya',
    population: 475000,
    estimatedChronicDiseasePatients: 47500,
    latitude: 0.5143,
    longitude: 35.2698,
    currency: 'KES',
    languagePrimary: 'English',
    languageSecondary: 'Swahili',
    region: 'Rift Valley',
    status: 'planned',
    cityManagerRole: 'Role_CityManager_Eldoret',
  },
  {
    sequenceNumber: 6,
    cityName: 'Ruiru',
    displayName: 'Ruiru',
    adminDivision1: 'Kiambu County',
    adminDivision2: 'Ruiru',
    countryCode: 'KE',
    countryName: 'Kenya',
    population: 430000,
    estimatedChronicDiseasePatients: 43000,
    latitude: -1.1465,
    longitude: 36.9605,
    currency: 'KES',
    languagePrimary: 'English',
    languageSecondary: 'Swahili',
    region: 'Nairobi Metro',
    metroAreaDefinition: 'Nairobi Metro (separate market)',
    status: 'planned',
    cityManagerRole: 'Role_CityManager_Ruiru',
  },
  {
    sequenceNumber: 7,
    cityName: 'Kikuyu',
    displayName: 'Kikuyu',
    adminDivision1: 'Kiambu County',
    adminDivision2: 'Kikuyu',
    countryCode: 'KE',
    countryName: 'Kenya',
    population: 280000,
    estimatedChronicDiseasePatients: 28000,
    latitude: -1.2450,
    longitude: 36.6640,
    currency: 'KES',
    languagePrimary: 'English',
    languageSecondary: 'Swahili',
    region: 'Nairobi Metro',
    metroAreaDefinition: 'Nairobi Metro (separate market)',
    status: 'planned',
    cityManagerRole: 'Role_CityManager_Kikuyu',
  },
  {
    sequenceNumber: 8,
    cityName: 'Kangundo-Tala',
    displayName: 'Kangundo-Tala',
    adminDivision1: 'Machakos County',
    countryCode: 'KE',
    countryName: 'Kenya',
    population: 220000,
    estimatedChronicDiseasePatients: 22000,
    latitude: -1.2833,
    longitude: 37.4833,
    currency: 'KES',
    languagePrimary: 'English',
    languageSecondary: 'Swahili',
    region: 'Eastern',
    status: 'planned',
    cityManagerRole: 'Role_CityManager_Kangundo-Tala',
  },
  {
    sequenceNumber: 9,
    cityName: 'Malindi',
    displayName: 'Malindi',
    adminDivision1: 'Kilifi County',
    countryCode: 'KE',
    countryName: 'Kenya',
    population: 210000,
    estimatedChronicDiseasePatients: 21000,
    latitude: -3.2138,
    longitude: 40.1169,
    currency: 'KES',
    languagePrimary: 'English',
    languageSecondary: 'Swahili',
    region: 'Coastal',
    status: 'planned',
    cityManagerRole: 'Role_CityManager_Malindi',
  },
  {
    sequenceNumber: 10,
    cityName: 'Thika',
    displayName: 'Thika',
    adminDivision1: 'Kiambu County',
    adminDivision2: 'Thika',
    countryCode: 'KE',
    countryName: 'Kenya',
    population: 200000,
    estimatedChronicDiseasePatients: 20000,
    latitude: -1.0334,
    longitude: 37.0693,
    currency: 'KES',
    languagePrimary: 'English',
    languageSecondary: 'Swahili',
    region: 'Nairobi Metro',
    metroAreaDefinition: 'Nairobi Metro (separate market)',
    status: 'planned',
    cityManagerRole: 'Role_CityManager_Thika',
  },
  {
    sequenceNumber: 11,
    cityName: 'Kitui',
    displayName: 'Kitui',
    adminDivision1: 'Kitui County',
    countryCode: 'KE',
    countryName: 'Kenya',
    population: 180000,
    estimatedChronicDiseasePatients: 18000,
    latitude: -1.3667,
    longitude: 38.0167,
    currency: 'KES',
    languagePrimary: 'English',
    languageSecondary: 'Swahili',
    region: 'Eastern',
    status: 'planned',
    cityManagerRole: 'Role_CityManager_Kitui',
  },
  {
    sequenceNumber: 12,
    cityName: 'Machakos',
    displayName: 'Machakos',
    adminDivision1: 'Machakos County',
    countryCode: 'KE',
    countryName: 'Kenya',
    population: 150000,
    estimatedChronicDiseasePatients: 15000,
    latitude: -1.5177,
    longitude: 37.2634,
    currency: 'KES',
    languagePrimary: 'English',
    languageSecondary: 'Swahili',
    region: 'Eastern',
    status: 'planned',
    cityManagerRole: 'Role_CityManager_Machakos',
  },
  {
    sequenceNumber: 13,
    cityName: 'Athi River',
    displayName: 'Athi River',
    adminDivision1: 'Machakos County',
    adminDivision2: 'Mavoko',
    countryCode: 'KE',
    countryName: 'Kenya',
    population: 145000,
    estimatedChronicDiseasePatients: 14500,
    latitude: -1.4500,
    longitude: 36.9833,
    currency: 'KES',
    languagePrimary: 'English',
    languageSecondary: 'Swahili',
    region: 'Nairobi Metro',
    metroAreaDefinition: 'Nairobi Metro (separate market)',
    status: 'planned',
    cityManagerRole: 'Role_CityManager_Athi River',
  },
  {
    sequenceNumber: 14,
    cityName: 'Garissa',
    displayName: 'Garissa',
    adminDivision1: 'Garissa County',
    countryCode: 'KE',
    countryName: 'Kenya',
    population: 145000,
    estimatedChronicDiseasePatients: 14500,
    latitude: -0.4536,
    longitude: 39.6401,
    currency: 'KES',
    languagePrimary: 'English',
    languageSecondary: 'Swahili',
    region: 'North Eastern',
    status: 'planned',
    cityManagerRole: 'Role_CityManager_Garissa',
  },
  {
    sequenceNumber: 15,
    cityName: 'Naivasha',
    displayName: 'Naivasha',
    adminDivision1: 'Nakuru County',
    adminDivision2: 'Naivasha',
    countryCode: 'KE',
    countryName: 'Kenya',
    population: 140000,
    estimatedChronicDiseasePatients: 14000,
    latitude: -0.7172,
    longitude: 36.4320,
    currency: 'KES',
    languagePrimary: 'English',
    languageSecondary: 'Swahili',
    region: 'Rift Valley',
    status: 'planned',
    cityManagerRole: 'Role_CityManager_Naivasha',
  },
];

/**
 * Known Healthcare Facilities in Kenya
 * These can be pre-populated as potential MSI3 partners
 */
export const KENYA_FACILITIES = {
  nairobi: [
    {
      facilityName: 'Kenyatta National Hospital',
      tier: 1,
      bedCount: 1800,
      facilityType: 'National Referral Hospital',
    },
    {
      facilityName: 'Aga Khan University Hospital, Nairobi',
      tier: 1,
      bedCount: 300,
      facilityType: 'Teaching Hospital',
    },
    {
      facilityName: 'Nairobi Hospital',
      tier: 2,
      bedCount: 200,
      facilityType: 'Private Hospital',
    },
    {
      facilityName: 'MP Shah Hospital',
      tier: 2,
      bedCount: 200,
      facilityType: 'Private Hospital',
    },
    {
      facilityName: 'Mater Hospital Nairobi',
      tier: 2,
      bedCount: 300,
      facilityType: 'Private Hospital',
    },
    {
      facilityName: "Gertrude's Children's Hospital",
      tier: 2,
      bedCount: 150,
      facilityType: 'Pediatric Hospital',
    },
    {
      facilityName: 'Karen Hospital',
      tier: 2,
      bedCount: 200,
      facilityType: 'Private Hospital',
    },
    {
      facilityName: 'Coptic Hospital',
      tier: 3,
      bedCount: 100,
      facilityType: 'Community Hospital',
    },
  ],
  mombasa: [
    {
      facilityName: 'Aga Khan Hospital, Mombasa',
      tier: 2,
      bedCount: 150,
      facilityType: 'Private Hospital',
    },
    {
      facilityName: 'Coast Provincial General Hospital',
      tier: 2,
      bedCount: null,
      facilityType: 'County Referral Hospital',
    },
  ],
  kisumu: [
    {
      facilityName: 'Aga Khan Hospital, Kisumu',
      tier: 3,
      bedCount: 116,
      facilityType: 'Private Hospital',
    },
    {
      facilityName: 'Kisumu County Referral Hospital',
      tier: 2,
      bedCount: null,
      facilityType: 'County Referral Hospital',
    },
  ],
  nakuru: [
    {
      facilityName: 'Nakuru Level 5 Hospital',
      tier: 2,
      bedCount: 350,
      facilityType: 'County Referral Hospital',
    },
  ],
  eldoret: [
    {
      facilityName: 'Moi Teaching and Referral Hospital',
      tier: 1,
      bedCount: 800,
      facilityType: 'Teaching Hospital',
    },
  ],
};

/**
 * Get the next available sequence number for new cities
 * @param {Array} existingCities - Array of existing cities with sequenceNumber
 * @returns {number} - Next sequence number
 */
export const getNextSequenceNumber = (existingCities) => {
  if (!existingCities || existingCities.length === 0) {
    return 1;
  }
  const maxSeq = Math.max(...existingCities.map(c => c.sequenceNumber || 0));
  return maxSeq + 1;
};

/**
 * Generate role name for a city
 * @param {string} cityName - Name of the city
 * @returns {string} - Role name in format Role_CityManager_{CityName}
 */
export const generateCityManagerRoleName = (cityName) => {
  return `Role_CityManager_${cityName}`;
};

/**
 * Helper to seed Kenya cities into Firestore
 * @param {Object} db - Firestore database instance
 * @param {boolean} force - If true, will overwrite existing data
 */
export const seedKenyaCities = async (db, force = false) => {
  // Check if cities already exist
  const existingSnapshot = await db.collection('msi3PopulationCenters')
    .where('countryCode', '==', 'KE')
    .limit(1)
    .get();

  if (!existingSnapshot.empty && !force) {
    return { seeded: false, count: 0 };
  }

  const batch = db.batch();
  
  for (const city of KENYA_CITIES) {
    const docRef = db.collection('msi3PopulationCenters').doc();
    batch.set(docRef, {
      ...city,
      createdAt: new Date(),
      updatedAt: new Date(),
    });
  }
  
  await batch.commit();
  return { seeded: true, count: KENYA_CITIES.length };
};

/**
 * Update existing cities with sequence numbers (migration helper)
 * @param {Object} db - Firestore database instance
 */
export const migrateAddSequenceNumbers = async (db) => {
  const snapshot = await db.collection('msi3PopulationCenters')
    .where('countryCode', '==', 'KE')
    .orderBy('population', 'desc')
    .get();

  if (snapshot.empty) {
    return { migrated: false, count: 0 };
  }

  const batch = db.batch();
  let sequenceNumber = 1;

  // Sort by population descending to assign sequence numbers
  const cities = snapshot.docs.map(doc => ({
    id: doc.id,
    ref: doc.ref,
    data: doc.data(),
  }));

  // Match with KENYA_CITIES data for correct sequence numbers
  for (const city of cities) {
    const matchingCity = KENYA_CITIES.find(
      kc => kc.cityName.toLowerCase() === city.data.cityName?.toLowerCase()
    );

    if (matchingCity) {
      batch.update(city.ref, {
        sequenceNumber: matchingCity.sequenceNumber,
        displayName: matchingCity.displayName,
        region: matchingCity.region,
        cityManagerRole: matchingCity.cityManagerRole,
        updatedAt: new Date(),
      });
    } else {
      // City not in original list, assign next available sequence
      batch.update(city.ref, {
        sequenceNumber: 100 + sequenceNumber++, // Start at 100 for unknown cities
        updatedAt: new Date(),
      });
    }
  }

  await batch.commit();
  return { migrated: true, count: cities.length };
};
